import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux';
import Slider from 'react-rangeslider';

// Bootstrap component
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';


// Component
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import ReviewPageSection from '../Section/ReviewPageSection';

// Assets
import './ReviewResponse.css';
import 'react-rangeslider/lib/index.css';

import { loadingSpinner } from '../../../actions/SurveyAction';
import { processResponse, stringFormat } from '../../../utilities/processResponse';

class ReviewResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open:false,
            secondModal:false,
            questionList:[],
            type:this.props.type || null,
            questionCheckBox:false,
            answeredCheckbox:false,
            unAnsweredCheckbox:false,
            showRequiredQuestion:false,
            isRequired:true
        };
        this.ansCount = 0;
        this.responseData = this.props.itemList || [];
    }

    static getDerivedStateFromProps = (props, state) => {
        const open = props.open;

        if (open !== state.open || props.itemList !== state.questionList || state.secondModal !== props.openSecond || props.type !== state.type) {
            return {
                open:open,
                secondModal:props.openSecond,
                questionList:[...state.questionList.concat(props.itemList)] || [],
                type:props.type
            }
		}
		return null;
    }

    componentDidUpdate(nextProps) {

        if(nextProps == this.props){
        const { itemList, totalQuestionCount } = this.props;
        var submitButtonClasses = document.getElementsByClassName("_SummaryPageSubmitAsFinalButton")[0];
        var isRequiredItem = 0;
        var isAnswerItem = 0;
        var isUnAnsweredItem = 0;
        if(submitButtonClasses == undefined || submitButtonClasses.offsetParent == null) {
            return;
        }

        for (const key in itemList) {
            if (itemList.hasOwnProperty(key)) {
                const element = itemList[key];

                for (const key in element) {
                    if (element.hasOwnProperty(key)) {
                        const tempArr = element[key];

                        if (tempArr.isRequired === true && tempArr.requiredIndicator === 2) {
                            isRequiredItem++;
                        }
                        if (tempArr.isAnswer === true) {
                            isAnswerItem++;
                        }
                        if (tempArr.isAnswer === false) {
                            isUnAnsweredItem++;
                        }
                    }
                }
            }
        }


        if(submitButtonClasses) {
            if (totalQuestionCount === isAnswerItem) {
                submitButtonClasses.classList.add("_ButtonAllAnswered");
                submitButtonClasses.classList.remove("_ButtonRequired");

            } else if (isRequiredItem !== 0) {
                submitButtonClasses.classList.add("_ButtonRequired");

            } else if (isUnAnsweredItem !== 0) {
                submitButtonClasses.classList.remove("_ButtonRequired");
                //submitButtonClasses.classList.add("_ButtonUnAnswered");
            } else {
                console.log("default")
            }
        }
     return true
    }else {
        return false
        }
    }

    /**
     * Method to open review and unanswered modal from finalize modal
     *
     * @param { type:string } type
     *
     */
    openModal = (type) => {

        if (type === "unanswered") {
            this.setState({unAnsweredCheckbox:true});

        } else if (type === "review" || type === "answered") {
            this.setState({
                secondModal:false,
                open:true,
                answeredCheckbox:true
            });
        } else {
            this.setState({questionCheckBox:true, secondModal:true});
        }
    }

    /**
     * Method to filter answered question
     *
     */
    handleAnsweredCheckbox = (e) => {
        this.setState({answeredCheckbox:e.target.checked});
    }

    /**
     * Method to filter unanswered question
     *
     */
    handleUnAnsweredCheckbox = (e) => {
        this.setState({unAnsweredCheckbox:e.target.checked});
    }

    /**
     * Method to filter unanswered question
     *
     */
    handleRequiredCheckbox = (e) => {
        this.setState({showRequiredQuestion:e.target.checked});
    }

    /**
     * Method to redirect respective page based on question click.
     *
     * @param { activePageNumber:Number} activePageNumber
     *
     */
    redirectToPage = (activePageNumber, questionId) => {
        const { onNextButtonClick, onCloseModal, scrollToDiv } = this.props;
        onNextButtonClick(null, "review", activePageNumber);
        scrollToDiv(questionId);
        onCloseModal(null, null);
    }

    /**
     * Method to close modal.
     *
     */
    closeModal = (type) =>  {
        this.setState({questionCheckBox:true, secondModal:false, open:true});
        this.props.onCloseModal(type, null);
    }


    backToSurvey = () => {
        this.props.onCloseModal(null, null);
        this.setState({
            answeredCheckbox:false,
            unAnsweredCheckbox:false,
            showRequiredQuestion:false
        });
        this.props.onBackToPage();
        this.props.onNextButtonClick(null, "reviewButton", this.props.currentActivePageCount);
    }

    handleFinalAsSubmitButton = () => {
        const { dispatch, itemResponses } = this.props;

        if (Object.keys(itemResponses).length !== 0) {
            dispatch(loadingSpinner(true));
            this.props.handleFinalAsSubmitButton(null, null, null, "FinalSubmit");
            this.props.onCloseModal(null, "reviewPage");
        }
    }

    /**
     * Method to render question list view.
     *
     * @param { item:object } item
     * @return { Element } return html element
     *
     */
   	renderView = (item) => {
        const unansweredText = item.ratees.length > 1 ? "Unanswered for all" : "Unanswered";
        var userItem = item.userResponse.filter((el, i) =>  el != null);

        var jsx = "";
        return <div className="ReviewModalContent"
                    onClick={() => this.redirectToPage(item.activePageNumber, item.key)}
                >
                    <div className="ReviewModalTitle">
                        {item.itemTag}
                        <div>
                            {item.isRequired === true ? <span className="Error_handle">*</span> :''}
                            {item.itemText}
                        </div>
                    </div>
                    {userItem.length > 0 ?
                        item.choiceType === "Multiple" ?
                            item.ratees.map((list, i) => {
                                var answeredItem = userItem.map((userResponse, i) => {
                                    if (userResponse.rateeKey === list.key) {
                                        return userResponse.userResponseDescription;
                                    } else {
                                        return null;
                                    }
                                }).filter(Boolean);

                                if (answeredItem.length === 0) {
                                    answeredItem[0] = "Unanswered";
                                }
                                var response = answeredItem.filter((itm, i) => {
                                    return itm;
                                }).join(", ");

                                jsx = (
                                    <div className="ReviewModalText" >
                                        { response }
                                        <span>&nbsp;&nbsp;{ item.ratees.length > 1 ? "(" + list.participantName + ")" : null}</span>
                                    </div>
                                )
                                return jsx;
                            })
                            :
                            item.ratees.map((list, i) => {
                                var userResponse = item.userResponse[i] || [];
                                return list.key === userResponse.rateeKey ?
                                        <div className="ReviewModalText" >
                                            {userResponse.userResponseDescription ||  <div className="ReviewModalUnansweredText">Unanswered</div>}
                                            <span>&nbsp;&nbsp;{ item.ratees.length > 1 ? "(" + list.participantName + ")" : null}</span>
                                        </div>
                                        :
                                        <div className="ReviewModalText">
                                            <div className="ReviewModalUnansweredText">
                                                Unanswered &nbsp;<span> ({list.participantName}) </span>
                                            </div>
                                        </div>
                                })
                                :
                                <div className="ReviewModalText">
                                    <div className="ReviewModalUnansweredText">
                                        {unansweredText}
                                    </div>
                                </div>
                            }
                        </div>
    }

    renderPointAsmSuccessSlider = (props) => {
        return <Card.Title className="slider-block-success">
                    <Slider
                        min={0}
                        max={100}
                        value={props.responseValue}
                        handleLabel={props.responseValue}
                        tooltip={false}
                        disabled={true}
                    />
                </Card.Title>
    }

    renderPointAsmDangerSlider = () => {
        return <Card.Title className="slider-block-danger">
                    <Slider
                        min={0}
                        max={100}
                        value={50}
                        handleLabel={null}
                        tooltip={false}
                        disabled={true}
                    />
                </Card.Title>
    }

    renderPointAsmRequiredSlider = () => {
        return <Card.Title className="slider-block-danger">
                    <Slider
                        min={0}
                        max={100}
                        value={50}
                        handleLabel={null}
                        tooltip={false}
                        disabled={true}
                    />
                </Card.Title>
    }

    renderPointAsmNaSlider = (props) => {
        return <Card.Title className="slider-block-default">
                    <Slider
                        min={0}
                        max={100}
                        value={50}
                        handleLabel={null}
                        tooltip={false}
                        disabled={true}
                    />
                </Card.Title>
    }

    renderSuccessSlider = (items) => {
        const { scales } = this.props.pageInstrumentConfiguration;
        var tempScaleResponse = [];

        return items.map((itemResponse, i) => {
            const { scaleResponses, itemTypeProperties } = scales[itemResponse.scaleKey];
            tempScaleResponse[itemResponse.key] = scaleResponses;

            if (itemResponse.isAnswer === true && itemResponse.scaleKey !== null) {
                return <Card.Title className="slider-block-success">
                            <Slider
                                min={parseInt(itemTypeProperties.min)}
                                max={parseInt(itemTypeProperties.max)}
                                value={itemResponse.itemResponses[itemResponse.key][0].responseValue}
                                // handleLabel={itemResponse.itemResponses[itemResponse.key][0].responseValue}
                                tooltip={false}
                                disabled={true}
                            />
                            <div className="left-label-success">
                                <span>{tempScaleResponse[itemResponse.key][0].responseDescription}</span>
                            </div>
                            <div className="right-label-success">
                                <span>{tempScaleResponse[itemResponse.key][1].responseDescription}</span>
                            </div>
                    </Card.Title>
            }
            return undefined;
        })
    }

    renderRequiredSlider = (items) => {
        const { scales } = this.props.pageInstrumentConfiguration;
        var leftDes = null;
        var rightDes = null;
        var responseValue = 0;

        return items.map((itemResponse, i) => {
            const { scaleResponses, itemTypeProperties } = scales[itemResponse.scaleKey];

            for (const key in scaleResponses) {
                if (scaleResponses.hasOwnProperty(key)) {
                    leftDes = scaleResponses[0].responseDescription;
                    rightDes = scaleResponses[1].responseDescription;
                }
            }

            const itemResponseSet = itemResponse.itemResponses[itemResponse.key];

            for (const key in itemResponseSet) {
                if (itemResponseSet.hasOwnProperty(key)) {
                    const element = itemResponseSet[key];
                    responseValue = element.responseValue;
                }
            }

            if (itemResponse.isAnswer === false && itemResponse.scaleKey !== null) {
                return <Card.Title className="slider-block-danger">
                            <Slider
                                min={parseInt(itemTypeProperties.min)}
                                max={parseInt(itemTypeProperties.max)}
                                value={(parseInt(itemTypeProperties.max) / 2) + 0.5}
                                handleLabel={null}
                                tooltip={false}
                                disabled={true}
                            />
                            <div className="left-label-danger">
                                <span>{leftDes && leftDes !== undefined ? leftDes : null}</span>
                            </div>
                            <div className="right-label-danger">
                                <span>{rightDes && rightDes !== undefined ? rightDes : null}</span>
                            </div>
                    </Card.Title>
            } else if (itemResponse.scaleKey !== null) {
                return <Card.Title className="slider-block-success">
                            <Slider
                                min={parseInt(itemTypeProperties.min)}
                                max={parseInt(itemTypeProperties.max)}
                                value={responseValue}
                                // handleLabel={itemResponse.itemResponses[itemResponse.key][0].responseValue.toFixed(0)}
                                tooltip={false}
                                disabled={true}
                            />
                            <div className="left-label-success">
                                <span>{leftDes && leftDes !== undefined ? leftDes : null}</span>
                            </div>
                            <div className="right-label-success">
                                <span>{rightDes && rightDes !== undefined ? rightDes : null}</span>
                            </div>
                    </Card.Title>
            }
            return undefined;
        })
    }

    renderNaSlider = (items) => {
        const { scales } = this.props.pageInstrumentConfiguration;
        var leftDes = null;
        var rightDes = null;
        var responseValue = 0;

        return items && items.length > 0 && items.map((itemResponse, i) => {
            const { scaleResponses, itemTypeProperties } = scales[itemResponse.scaleKey];

            for (const key in scaleResponses) {
                if (scaleResponses.hasOwnProperty(key)) {
                    leftDes = scaleResponses[0].responseDescription;
                    rightDes = scaleResponses[1].responseDescription;
                }
            }
            const itemResponseSet = itemResponse.itemResponses[itemResponse.key];

            for (const key in itemResponseSet) {
                if (itemResponseSet.hasOwnProperty(key)) {
                    const element = itemResponseSet[key];
                    responseValue = element.responseValue;
                }
            }

            if (itemResponse.isAnswer === false && itemResponse.key !== null) {
                return <Card.Title className="slider-block-default">
                            <Slider
                                min={parseInt(itemTypeProperties.min)}
                                max={parseInt(itemTypeProperties.max)}
                                value={(parseInt(itemTypeProperties.max) / 2) + 0.5}
                                handleLabel={null}
                                tooltip={false}
                                disabled={true}
                            />
                            <div className="left-label-success">
                                <span>{leftDes && leftDes !== undefined ? leftDes : null}</span>
                            </div>
                            <div className="right-label-success">
                                <span>{rightDes && rightDes !== undefined ? rightDes : null}</span>
                            </div>
                    </Card.Title>
            } else if (itemResponse.scaleKey !== null) {
                return <Card.Title className="slider-block-success">
                            <Slider
                                min={parseInt(itemTypeProperties.min)}
                                max={parseInt(itemTypeProperties.max)}
                                value={responseValue}
                                // handleLabel={itemResponse.itemResponses[itemResponse.key][0].responseValue.toFixed(0)}
                                tooltip={false}
                                disabled={true}
                            />
                            <div className="left-label-success">
                                <span>{leftDes && leftDes !== undefined ? leftDes : null}</span>
                            </div>
                            <div className="right-label-success">
                                <span>{rightDes && rightDes !== undefined ? rightDes : null}</span>
                            </div>
                    </Card.Title>
            }
            return undefined;
        });
    }

    renderMultiSelectSuccess = (props) => {
        const { scales } = this.props.pageInstrumentConfiguration;

        return props.map((items, ind) => {
            const { scaleResponses, itemType } = scales[items.scaleKey];

            var response = null;
            var itemKey = items.key;

            if (items.isAnswer === true && items.scaleKey !== null) {
                var itemResponse = itemType === "3" ? items.itemResponses[itemKey] : items.userResponse;

                return itemResponse.map((itemRes, index) => {
                    for (const key in scaleResponses) {
                        if (scaleResponses.hasOwnProperty(key)) {
                            const tempScaleResponses = scaleResponses[key];

                            if (itemRes.response !== null && (tempScaleResponses.response) === (itemRes.response)) {
                                response = tempScaleResponses.responseDescription;
                            }
                        }
                    }
                    return <Card.Title className="single-response-block">
                            {itemType === "3" ? <span className="single-answered-label-na"><p>{index + 1}</p></span>: itemResponse.length > 0 ? <li className="multi-select-list"></li>:null}
                            <span className="single-answered-label-na">{response !== null ? response: null}</span>
                        </Card.Title>
                })
            } else {
                return <Card.Title className="single-response-block">
                        <span className="single-answered-label-danger">- Unanswered</span>
                    </Card.Title>
            }
        });
    }

    renderImageItemTypeSuccess = (props) => {
        var selectedImageCount = 0;
        return props.map((items, ind) => {
            if (items.isAnswer === true && items.scaleKey !== null) {
                var itemResponse = items.userResponse;
                    itemResponse.forEach(element => {
                        if (element.responseValue !== null) {
                            selectedImageCount++;
                        }
                    });

                    return <Card.Title className="single-response-block">
                            {/* {itemType === "3" ? <span className="single-answered-label-na"><p>{index + 1}</p></span>: itemResponse.length > 0 ? <li className="multi-select-list"></li>:null} */}
                            <span className="single-answered-label-na">{itemResponse.length}</span>
                        </Card.Title>
            } else {
                return <Card.Title className="single-response-block">
                        <span className="single-answered-label-danger">- Unanswered</span>
                    </Card.Title>
            }
        });
    }

    renderSuccessResponse = (props) => {
        const { scales } = this.props.pageInstrumentConfiguration;

        return props.map((items, ind) => {
            const { scaleResponses } = scales[items.scaleKey];

            if (items.isAnswer === true && items.scaleKey !== null) {
                var itemResponse = items.itemResponses[items.key];
                var response = null;

                for (const key in itemResponse) {
                    if (itemResponse.hasOwnProperty(key)) {
                        const element = itemResponse[key];

                        for (const key in scaleResponses) {
                            if (scaleResponses.hasOwnProperty(key)) {
                                const tempScaleResponses = scaleResponses[key];

                                if (tempScaleResponses.response === element.response) {
                                    response = tempScaleResponses.responseDescription;
                                }
                            }
                        }

                        response = element.openEnd !== null ? element.openEnd : response;
                        return <Card.Title className="single-response-block">
                                {props.length > 1 ? <span className="single-circle-success"><p>{ ind || "1"}</p></span>:null}
                                <span className="single-answered-label-na">{response}</span>
                            </Card.Title>
                    }
                }

            } else {
                return <Card.Title className="single-response-block">
                        <span className="single-answered-label-danger">- Unanswered</span>
                    </Card.Title>
            }
            return undefined;
        });
    }

    renderUnansweredResponse = (props) => {
        return <Card.Title className="single-response-block">
            <span className="single-answered-label-danger">- Unanswered</span>
        </Card.Title>
    }

    renderNaResponse = (item) => {
        return <Card.Title className="single-response-block">
                    <span className="single-answered-label-na">n/a</span>
            </Card.Title>
    }

    renderEntrySuccessResponse = (items, index) => {
        var itemResponses = [];

        if (items.itemResponses && items.itemResponses[items.key] !== undefined) {
            itemResponses = items.itemResponses[items.key][0]
        } else {
            itemResponses = []
        }
        if (itemResponses.openEnd !== null) {
            return <Card.Title className="single-response-block">
                    <span className="single-circle-success"><p>{index || "1"}</p></span>
                    <span className="single-answered-label-na">{itemResponses.responseValue || itemResponses.openEnd}</span>
                </Card.Title>
        } else {
            return <Card.Title className="single-response-block">
                        <span className={items.isRequired !== true ? "single-circle-na":"single-circle-danger"}><p>{ index || "1"}</p></span>
                        <span className={items.isRequired !== true ? "single-answered-label-na":"single-answered-label-danger"}><i>- You left blank -</i></span>
                    </Card.Title>
        }
    }

    renderEntryNaResponse = (props, i) => {
        return <Card.Title className="single-response-block">
                    <span className="single-circle-na"><p>{i || 1}</p></span>
                    <span className="single-answered-label-na">- n/a</span>
            </Card.Title>
    }

    renderEntryUnansweredResponse = (props, i) => {
        var responseValue = null;
        var openEnd = null;

        return props.map((items, ind) => {
            for (const key in items.itemResponses) {
                if (items.itemResponses.hasOwnProperty(key)) {
                    const element = items.itemResponses[key];
                    responseValue = element[0].responseValue;
                    openEnd = element[0].openEnd;
                }
            }
            if (items.isAnswer !== true && items.scaleKey !== null) {
                return <Card.Title className="single-response-block">
                        {props.length > 1 ? <span className={items.isRequired !== true ? "single-circle-na":"single-circle-danger"}><p>{ ind + 1 || "1"}</p></span>:null}
                        <span className={items.isRequired !== true ? "single-answered-label-na":"single-answered-label-danger"}><i>- You left blank -</i></span>
                    </Card.Title>
            } else if(items.scaleKey !== null ) {
                return this.renderEntrySuccessResponse(items, ind)
            }
            return undefined;
       });
    }

    renderEntryRequiredResponse = (props) => {

        return props.map((items, ind) => {
            if (items.isAnswer !== true && items.scaleKey !== null) {
                return <Card.Title className="single-response-block">
                        {props.length > 1 ? <span className="single-circle-danger"><p>{ind + 1 || "1"}</p></span>:null}
                        <span className="single-answered-label-danger"><i>- You left blank -</i></span>
                    </Card.Title>
            } else if(items.scaleKey !== null) {
                return this.renderEntrySuccessResponse(items, ind)
            }
            return undefined;
        });
    }

    renderSuccessCard = (props) => {
        const items = this.props.itemList[props.reviewPageKey];
        const { scales } = this.props.pageInstrumentConfiguration;

        var tempHint = null;
        var isRequired = 0;
        var tempItems = [];
        var layoutHints = null;

        for (const key in items) {
            if (items.hasOwnProperty(key)) {
                const element = items[key];

                if (element.isRequired === true && element.requiredIndicator === 2 && element.scaleKey !== null) {
                    isRequired++;
                }

                if (element.scaleKey !== null) {
                    tempHint = scales[props.scaleKey !== null ? props.scaleKey: element.scaleKey];
                    tempItems.push(items[key]);
                    layoutHints = items[key].layoutHints;
                }
            }
        }

        return <Col md="4" className={isRequired !== 0 ? 'card-required':'card-success'}>
                    <Card className="text-left">
                        <Card.Body>
                            <Card.Title className="text-center">
                                <span className={isRequired === 0 ? "circle-success":"circle-required"}></span>
                            </Card.Title>
                                {props.itemText !== null ?
                                <Card.Text className={isRequired === 0 ? "card-question-label-success":"card-question-label-danger"}>
                                {props.itemText !== null ? <span className="item-text-label">
                                    {props.isRequired === true ? "*" : null}
                                    {props.itemTag}&nbsp;
                                <div dangerouslySetInnerHTML={{__html:processResponse(props.itemText)}}></div></span>:null}
                            </Card.Text>:null}
                                {
                                        props.layoutHints ==="pointoptioninputslider" ?
                                            this.renderPointAsmSuccessSlider(items)

                                        : layoutHints !== null && layoutHints === "slider" ?
                                            this.renderNaSlider(tempItems)

                                        : tempHint.renderingHint === "textarea"?
                                            this.renderSuccessResponse(tempItems)

                                        : tempHint.renderingHint === "textbox" ?
                                            this.renderEntryUnansweredResponse(items)

                                        : props.layoutHints === "vertical" && tempHint.itemType !== "2" && tempHint.itemType !== "102" ?
                                            this.renderSuccessResponse(items)

                                        : props.layoutHints === "vertical" && tempHint.itemType === "2" && tempHint.itemType !== "102" ?
                                            this.renderMultiSelectSuccess(items)

                                        : props.layoutHints === "vertical" && tempHint.itemType === "102"?
                                            this.renderMultiSelectSuccess(items)

                                        : tempHint.renderingHint === null && tempHint.itemType === "3"?
                                            this.renderMultiSelectSuccess(items)

                                        : tempHint.renderingHint === null && tempHint.itemType === "5"?
                                            this.renderImageItemTypeSuccess(items)
                                        :null
                                }
                        </Card.Body>
                        <Card.Footer className={isRequired === 0 ? "card-footer-success" : "card-footer-danger"}>
                            <i class="fa fa-pencil-square-o" aria-hidden="true" onClick={() => this.redirectToPage(props.activePageNumber, props.key)}></i>
                        </Card.Footer>
                    </Card>
                </Col>
    }

    renderUnansweredCard = (props) => {
        const items = this.props.itemList[props.reviewPageKey];
        const { scales } = this.props.pageInstrumentConfiguration;

        var tempHint = null;
        var tempItems = []
        var layoutHints = null;

        for (const key in items) {
            if (items.hasOwnProperty(key)) {
                const element = items[key];

                if (element.scaleKey !== null) {
                    tempHint = scales[props.scaleKey !== null ? props.scaleKey: element.scaleKey];
                    tempItems.push(items[key]);
                    layoutHints = items[key].layoutHints;
                }
            }
        }

        return <Col md="4" className="card-danger" key={props.key}>
                    <Card className="text-left">
                        <Card.Body>
                            <Card.Title className="text-center">
                                <span className="circle-danger"></span>
                            </Card.Title>
                            <Card.Text className="card-question-label-success">
                                {props.isRequired === true ? "*" : null}
                                <span className="item-text-label">{props.itemTag}&nbsp;
                                <div dangerouslySetInnerHTML={{__html:processResponse(props.itemText)}}></div></span>
                            </Card.Text>
                            {
                                layoutHints !== null && layoutHints === "slider" || props.itemType === "4"?
                                    this.renderNaSlider(tempItems)

                                :tempHint !== null && tempHint.renderingHint === "textarea" ?
                                    this.renderSuccessResponse(tempItems)

                                :tempHint !== null && tempHint.renderingHint === "textbox" ?
                                    this.renderEntryUnansweredResponse(tempItems)

                                :layoutHints === "vertical"?
                                    this.renderSuccessResponse(tempItems)

                                : props.layoutHints === "vertical" && tempHint.itemType !== "2" && tempHint.itemType !== "102" ?
                                    this.renderEntryUnansweredResponse(items)

                                : props.layoutHints === "vertical" && tempHint.itemType === "2" && tempHint.itemType !== "102" ?
                                    this.renderUnansweredResponse(items)

                                : props.layoutHints === "vertical" && tempHint.itemType === "102"?
                                    this.renderUnansweredResponse(tempItems)

                                : tempHint.renderingHint === null && tempHint.itemType === "3"?
                                    this.renderUnansweredResponse(tempItems)

                                : tempHint.renderingHint === null && tempHint.itemType === "5"?
                                    this.renderUnansweredResponse(tempItems)
                                :null
                            }
                        </Card.Body>
                        <Card.Footer className="card-footer-danger">
                            <i className="fa fa-pencil-square-o" aria-hidden="true" onClick={() => this.redirectToPage(props.activePageNumber, props.key)}></i>
                        </Card.Footer>
                    </Card>
                </Col>
    }

    renderRequiredCard = (props) => {
        const items = this.props.itemList[props.reviewPageKey];
        const { scales } = this.props.pageInstrumentConfiguration;
        var tempHint = null;
        var tempItems = []
        var layoutHints = null;

        for (const key in items) {
            if (items.hasOwnProperty(key)) {
                const element = items[key];

                if (element.scaleKey !== null) {
                    tempHint = scales[props.scaleKey !== null ? props.scaleKey: element.scaleKey];
                    tempItems.push(items[key]);
                    layoutHints = items[key].layoutHints;
                }
            }
        }

        return <Col md="4" className="card-required">
                <Card className="text-left">
                    <Card.Body>
                        <Card.Title className="text-center">
                            <span className="circle-required"></span>
                        </Card.Title>
                        <Card.Text className="card-question-label-danger">
                        <span className="item-text-required-label">{"*"} {props.itemTag} &nbsp; {props.itemText}</span>
                        </Card.Text>
                            {
                                layoutHints === "slider" ?
                                    this.renderRequiredSlider(tempItems)

                                :tempHint !== null && tempHint.renderingHint === "textarea"?
                                    this.renderEntryRequiredResponse(tempItems)

                                :tempHint !== null && tempHint.renderingHint === "textbox"?
                                    this.renderEntryRequiredResponse(tempItems)

                                :props.layoutHints === "vertical"?
                                    this.renderSuccessResponse(tempItems)

                                : props.layoutHints === "vertical" && tempHint.itemType !== "2" && tempHint.itemType !== "102" ?
                                    this.renderEntryUnansweredResponse(items)

                                : props.layoutHints === "vertical" && tempHint.itemType === "2" && tempHint.itemType !== "102" ?
                                    this.renderUnansweredResponse(items)

                                : props.layoutHints === "vertical" && tempHint.itemType === "102"?
                                    this.renderUnansweredResponse(tempItems)

                                : tempHint.renderingHint === null && tempHint.itemType === "3"?
                                    this.renderUnansweredResponse(tempItems)

                                : tempHint.renderingHint === null && tempHint.itemType === "5"?
                                    this.renderUnansweredResponse(tempItems)
                                :null
                            }
                        </Card.Body>
                    <Card.Footer className="card-footer-danger">
                        <i class="fa fa-pencil-square-o" aria-hidden="true" onClick={() => this.redirectToPage(props.activePageNumber, props.key)}></i>
                    </Card.Footer>
                </Card>
            </Col>
    }

    renderNaCard = (props) => {
        const items = this.props.itemList[props.reviewPageKey];
        const { scales } = this.props.pageInstrumentConfiguration;
        var tempHint = null;
        var tempItems = []
        var layoutHints = null;
        for (const key in items) {
            if (items.hasOwnProperty(key)) {
                const element = items[key];

                if (element.scaleKey !== null) {
                    tempHint = scales[props.scaleKey !== null ? props.scaleKey: element.scaleKey];
                    tempItems.push(items[key]);
                    layoutHints = items[key].layoutHints;
                }
            }
        }
        return <Col md="4" className="card-na">
                <Card className="text-left">
                    <Card.Body>
                        <Card.Title className="text-center">
                            <span className="circle-na"></span>
                            <span className="na-label">na</span>
                        </Card.Title>
                        <Card.Text className="card-question-label-na">
                            <span className="item-text-label">{props.isRequired === true ? "*" : null} {props.itemTag} &nbsp; {props.itemText}</span>
                        </Card.Text>
                            {
                                layoutHints === "slider"?
                                this.renderNaSlider(tempItems) :
                                tempHint !== null && tempHint.renderingHint === "textarea"?
                                this.renderEntryNaResponse(tempItems):
                                this.renderNaResponse()
                            }

                    </Card.Body>
                    <Card.Footer className="card-footer-na">
                        <i class="fa fa-pencil-square-o" aria-hidden="true" onClick={() => this.redirectToPage(props.activePageNumber, props.key)}></i>
                    </Card.Footer>
                </Card>
            </Col>
    }

    render() {
        const { open, showRequiredQuestion, answeredCheckbox, unAnsweredCheckbox } = this.state;
        const { pageInstrumentConfiguration, itemList } = this.props;

        const {
            pageBackButtonKey,
            pageExitButtonKey,
            properties,
            buttons,
            scales,
            sections,
            reviewPage,
            activeButtonCssClass,
            inactiveButtonCssClass,
            suppressSaveForLater
        } = pageInstrumentConfiguration;

        const {
            key,
            pagePreSectionKey,
            pagePostSectionKey,
            introForUnansweredRequiredSectionKey,
            introForUnansweredUnrequiredSectionKey,
            introForAssessmentClosedSectionKey,
            completedFormatStringPropertyKey,
            unansweredFormatStringPropertyKey,
            submitAsFinalButtonKey,
            saveForLaterWorkButtonKey,
            activeTabCssClass,
            inactiveTabCssClass,
            showOnlyRequiredLabel,
            hasPageExitButton,
            pageCssClass
        } = reviewPage;

        const completeFormat = processResponse(properties[completedFormatStringPropertyKey]);
        const unansweredFormat = processResponse(properties[unansweredFormatStringPropertyKey]);

        var answeredQuestion = 0;
        var unAnsweredCount = 0;
        var isRequired = 0;
        var tempListItems = [];

        for (const key in itemList) {
            if (itemList.hasOwnProperty(key)) {
                const listItems = itemList[key];
                for (const key in listItems) {
                    if (listItems.hasOwnProperty(key)) {
                        const element = listItems[key];

                        if (element.scaleKey !== null && element.isRequired === true && element.reviewPageKey === element.reviewPageKey) {
                            isRequired = 1;
                        }
                    }
                }
                tempListItems.push(listItems[0])
            }
        }

        if (tempListItems) {

            var listOfQuestion = tempListItems.filter((item, i) => {

                if (tempListItems.indexOf(item) === i) {

                    /* Required question count */
                    if (item.isRequired === true) {
                        isRequired++;
                    }

                    /* Answered and unaswered question count */
                    if (item.isAnswer === true || item.isNA === true) {
                        answeredQuestion++;
                        // isRequired = item.isRequired === true ? isRequired = isRequired - 1 : isRequired;
                    } else {
                        unAnsweredCount++;
                    }

                    /* Filter for answered and unaswered question */
                    if (unAnsweredCheckbox === true && answeredCheckbox !== true || this.props.unAnswered === true) {
                        if (item.isAnswer !== true) {
                            return tempListItems;
                        }
                    } else if (answeredCheckbox === true && unAnsweredCheckbox !== true ||  this.props.answered === true) {
                        if (item.isAnswer === true) {
                            return tempListItems;
                        }
                    } else if (answeredCheckbox === true && unAnsweredCheckbox === true) {
                        if (item.isAnswer === true || item.isAnswer !== true) {
                            return tempListItems;
                        }
                    } else if (showRequiredQuestion === true) {
                        if (item.isRequired === true) {
                            return tempListItems;
                        }
                    } else {
                        return tempListItems;
                    }
                }
                return undefined;
            });
        }

        return (
            <Fragment>
                <Modal
                    key={key}
                    open={open}
                    onClose={() => this.closeModal("review")}
                    showCloseIcon={false}
                    classNames={{
                        overlay:'reviewModal',
                    }}
                    className={pageCssClass}
                    center
                >
                    <Container>
                        <Row>
                            <Col xs="2">
                                {pageBackButtonKey !== null && buttons.hasOwnProperty(pageBackButtonKey) && buttons[pageBackButtonKey].buttonOption !== 0 ? <Button key={buttons[pageBackButtonKey].key}
                                    className={`_PageBackButton ${buttons[pageBackButtonKey].buttonCssClass}`}
                                    size="lg" onClick={this.backToSurvey}
                                >
                                    <i className={buttons[pageBackButtonKey].buttonFontAwesome} aria-hidden="true"></i>
                                    <span>
                                        &nbsp;{buttons[pageBackButtonKey].buttonText}
                                    </span>
                                </Button>:null}
                            </Col>
                            <Col xs="10" className="text-right">
                                {hasPageExitButton && pageExitButtonKey !== null && buttons.hasOwnProperty(pageExitButtonKey) && buttons[pageExitButtonKey].buttonOption !== 0 ? <Button
                                    key={buttons[pageExitButtonKey].key}
                                    className={`_PageExitButton ${buttons[pageExitButtonKey].buttonCssClass}`}
                                    size="lg">
                                        <i className={buttons[pageExitButtonKey].buttonFontAwesome} aria-hidden="true"></i>
                                </Button>:null}
                            </Col>
                        </Row>
                        {sections.hasOwnProperty(pagePreSectionKey) ?
                        <ReviewPageSection
                            key={sections[pagePreSectionKey].key}
                            type='pre'
                            html={sections[pagePreSectionKey].content}
                            className={`_ReviewPagePreSection ${sections[pagePreSectionKey].className}`}
                        />:null}
                    </Container>
                    <Container>
                        <Row>
                            {sections.hasOwnProperty(introForUnansweredRequiredSectionKey) ? <><Col md="2"></Col><Col md="8" className="text-center">

                                {isRequired !== 0 ?
                                <p
                                    key={sections.hasOwnProperty("key") !== false ? sections[introForUnansweredRequiredSectionKey].key: null}
                                    className={`_ReviewPageIntroForUnansweredRequiredSection ${sections[introForUnansweredRequiredSectionKey].className}`}
                                    dangerouslySetInnerHTML={{__html:processResponse(sections[introForUnansweredRequiredSectionKey].content)}}
                                ></p>
                                :unAnsweredCount !== 0 ?
                                <p
                                    key={sections[introForUnansweredUnrequiredSectionKey].key}
                                    className={`_ReviewPageIntroForUnansweredUnrequiredSection ${sections[introForUnansweredUnrequiredSectionKey].className}`}
                                    dangerouslySetInnerHTML={{__html:processResponse(sections[introForUnansweredUnrequiredSectionKey].content)}}
                                ></p>:
                                <p
                                    key={sections[introForAssessmentClosedSectionKey].key}
                                    className={`_ReviewPageIntroForAssessmentClosedSection ${sections[introForAssessmentClosedSectionKey].className}`}
                                    dangerouslySetInnerHTML={{__html:processResponse(sections[introForAssessmentClosedSectionKey].content)}}
                                ></p>
                                }
                                <br/>
                            </Col>
                            <Col md="2"></Col></>
                            :null}
                        </Row>
                        <Row>
                            <Col xs="3"></Col>
                            <Col md="6" className="text-center">
                            <Row>
                                <Col xs="3"></Col>
                                {
                                    this.state.type === "answered" ?
                                        <Col xs="3">
                                            <span className={`_ReviewPageActiveTab ${activeTabCssClass}`}>
                                                {stringFormat(completeFormat, answeredQuestion, this.props.totalQuestionCount, null, null)}
                                            </span><br/>
                                            <span>
                                                <input
                                                    className="reviewPageCheckbox"
                                                    type="checkbox"
                                                    checked={this.props.answered}
                                                    onChange={this.handleAnsweredCheckbox}
                                                />
                                            </span>
                                        </Col>
                                    :
                                        <Col xs="3">
                                            <span
                                                className={answeredCheckbox !== true ? unAnsweredCount !== 0 ?
                                                `_ReviewPageInactiveTab ${inactiveTabCssClass}`:
                                                `_ReviewPageActiveTab ${activeTabCssClass}` :
                                                `_ReviewPageActiveTab ${activeTabCssClass}`}
                                            >
                                                {stringFormat(completeFormat, answeredQuestion, this.props.totalQuestionCount, null, null)}
                                            </span>
                                            <br/>
                                            <span
                                                className={answeredCheckbox !== true ? unAnsweredCount !== 0 ?
                                                "":
                                                "ReviewPageActiveLine" :
                                                "ReviewPageActiveLine"}
                                            >
                                                <input
                                                    className="reviewPageCheckbox"
                                                    type="checkbox"
                                                    checked={unAnsweredCount === 0 ? !answeredCheckbox:answeredCheckbox}
                                                    onChange={this.handleAnsweredCheckbox}
                                                />
                                            </span>
                                        </Col>
                                    }
                                    {
                                        this.state.type === "unanswered" ?
                                            <Col xs="3">
                                                <span className={`_ReviewPageActiveTab ${activeTabCssClass}`}>
                                                    {stringFormat(unansweredFormat, unAnsweredCount, this.props.totalQuestionCount, null, null)}
                                                </span><br/>
                                                <span>
                                                    <input
                                                        className="reviewPageCheckbox"
                                                        type="checkbox"
                                                        checked={this.props.unAnswered}
                                                        onChange={this.handleUnAnsweredCheckbox}
                                                    />
                                                </span>
                                            </Col>
                                        :
                                            <Col xs="3">
                                                <span
                                                    className={unAnsweredCheckbox !== true ? unAnsweredCount !== 0 ?
                                                        `_ReviewPageInactiveTab ${inactiveTabCssClass}`:
                                                        `_ReviewPageActiveTab ${activeTabCssClass}`:
                                                        `_ReviewPageActiveTab ${activeTabCssClass}`}
                                                    >
                                                    {stringFormat(unansweredFormat, unAnsweredCount, this.props.totalQuestionCount, null, null)}
                                                </span><br/>
                                                <span
                                                    className={unAnsweredCheckbox !== true ? unAnsweredCount !== 0 ?
                                                    "":
                                                    "ReviewPageActiveLine" :
                                                    "ReviewPageActiveLine"}
                                                >
                                                    <input
                                                        className="reviewPageCheckbox"
                                                        type="checkbox"
                                                        checked={unAnsweredCount === 0 ? !unAnsweredCheckbox:unAnsweredCheckbox}
                                                        onChange={this.handleUnAnsweredCheckbox}
                                                    />
                                                </span>
                                            </Col>
                                    }
                                <Col xs="3"></Col>
                            </Row>
                            </Col>
                            <Col xs="3"></Col>
                        </Row>
                        <Row>
                            <Col md="4"></Col>
                            <Col md="4" className="text-center">
                                {/* {answeredQuestion > 0 ?  */}
                                    <Button
                                        className={isRequired === 0 && Object.keys(this.props.itemResponses).length !== 0 ? `_SummaryPageSubmitAsFinalButton ${buttons[submitAsFinalButtonKey].buttonCssClass}` : `_InactiveButton ${inactiveButtonCssClass}`}
                                        onClick={() => this.handleFinalAsSubmitButton()}
                                    >
                                        {buttons[submitAsFinalButtonKey].buttonText}
                                    </Button>
                            </Col>
                            <Col md="4"></Col>
                        </Row>
                        <Row>
                            <Col md="4"></Col>
                            <Col md="4" className="text-center">
                            {isRequired !== 0 && answeredQuestion > 0 && unAnsweredCheckbox ?
                                    <><input
                                        className="ReviewPageShowOnlyRequiredCheckbox"
                                        type="checkbox"
                                        onChange={this.handleRequiredCheckbox}
                                    />
                                        <label className="ReviewPageShowOnlyRequiredLabel">{showOnlyRequiredLabel}</label></>
                                    :null}
                            </Col>
                            <Col md="4"></Col>
                        </Row>
                    </Container>
                    <Container className="main-content">
                        <Row>
                            {
                                listOfQuestion !== undefined && listOfQuestion.length > 0 ?
                                listOfQuestion.map((item, i) => {
                                    var isAnswer = false;

                                    for (const key in itemList[item.reviewPageKey]) {
                                        if (itemList[item.reviewPageKey].hasOwnProperty(key)) {
                                            const tempItemList = itemList[item.reviewPageKey][key];

                                            if (tempItemList.scaleKey !== null) {
                                                isAnswer = tempItemList.isAnswer;
                                            }
                                        }
                                    }
                                    const scaleResponses = item.scaleKey !== null ? scales[item.scaleKey].scaleResponses : [];
                                    const tempScales = item.scaleKey !== null ? scales[item.scaleKey] : [];

                                    if (item.isAnswer === true) {
                                       return this.renderSuccessCard(item);

                                    } else if (item.isRequired === true && item.requiredIndicator === 2 && item.isNA !== true) {
                                        return this.renderRequiredCard(item);

                                    } else if (item.isAnswer === false && item.isNA !== true) {
                                        return this.renderUnansweredCard(item);

                                    } else if (item.isNA === true) {
                                        return this.renderNaCard(item);
                                    }
                                }) : null
                            }
                        </Row>
                    </Container>
                    <Container fluid>
                        <Row>
                            <Col md={3}></Col>
                            <Col md={6} className="text-center">
                                {!suppressSaveForLater && saveForLaterWorkButtonKey !== null && buttons.hasOwnProperty(saveForLaterWorkButtonKey) && buttons[saveForLaterWorkButtonKey].buttonOption !== 0 ? <Button
                                    key={buttons[saveForLaterWorkButtonKey].key}
                                    className={`_SummaryPageSaveForLaterWorkButton ${buttons[saveForLaterWorkButtonKey].buttonCssClass}`}
                                    onClick={(type) => {
                                        this.props.openSaveLaterPage("saveLater");
                                        this.props.handleItemResponse(null, this.props.itemResponses, "saveLater")
                                    }}
                                >
                                    {buttons[saveForLaterWorkButtonKey].buttonText}
                                </Button>:null}
                            </Col>
                            <Col md={3}></Col>
                        </Row>
                    </Container>
                    <Container>
                        {sections.hasOwnProperty(pagePostSectionKey) ?
                        <ReviewPageSection
                            key={sections[pagePostSectionKey].key}
                            type='post'
                            html={sections[pagePostSectionKey].content}
                            className={sections[pagePostSectionKey].className}
                        />:null}
                    </Container>
                </Modal>
            </Fragment>
        );
    }
};

const mapStateToProps = state => ({
    itemList:state.survey.itemList,
    isLoader:state.survey.isLoader
});

export default connect(mapStateToProps)(ReviewResponse);
